/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairBoardingPassDocumentType } from '../../models/finnair-boarding-pass-document-type';
import { FinnairOrder } from '../../models/finnair-order';
import { RequestInitiator } from '../../models/request-initiator';

export interface FetchOrder$Params {
  orderId: string;
  locale?: string;
  hash?: string;
  includeServiceCatalog?: boolean;
  includeRule24Eligibility?: boolean;
  includedBoardingPassTypes?: Array<FinnairBoardingPassDocumentType>;
  requestInitiator?: RequestInitiator;
  includePredictions?: boolean;
  frontEndQuota?: boolean;
}

export function fetchOrder(http: HttpClient, rootUrl: string, params: FetchOrder$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairOrder>> {
  const rb = new DapiRequestBuilder(rootUrl, fetchOrder.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.query('includeServiceCatalog', params.includeServiceCatalog, {});
    rb.query('includeRule24Eligibility', params.includeRule24Eligibility, {});
    rb.query('includedBoardingPassTypes', params.includedBoardingPassTypes, {});
    rb.query('requestInitiator', params.requestInitiator, {});
    rb.query('includePredictions', params.includePredictions, {});
    rb.query('frontEndQuota', params.frontEndQuota, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairOrder>;
    }),
    catchErrorAsJson()
  );
}

fetchOrder.PATH = '/api/v2/order/{orderId}';
